/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreInAppSteamSteamInAppBillingData } from './FxIdApplicationStoreInAppSteamSteamInAppBillingData';
import {
    instanceOfFxIdApplicationStoreInAppSteamSteamInAppBillingData,
    FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSON,
} from './FxIdApplicationStoreInAppSteamSteamInAppBillingData';

/**
 * @type FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData
 * 
 * @export
 */
export type FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData = FxIdApplicationStoreInAppSteamSteamInAppBillingData;

export function FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData {
    return FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppSteamSteamInAppBillingData(json)) {
        return FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSON(json: any): any {
    return FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreInAppSteamSteamInAppBillingData(value)) {
        return FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSON(value as FxIdApplicationStoreInAppSteamSteamInAppBillingData);
    }

    return {};
}

